
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M4.633 8.617A1.383 1.383 0 003.25 10v2.134a1.383 1.383 0 001.383 1.383h.317v-4.9h-.317zm-2.038-.655a2.883 2.883 0 012.038-.845h.534A1.283 1.283 0 016.45 8.401v5.333a1.283 1.283 0 01-1.283 1.283h-.534a2.883 2.883 0 01-2.883-2.883V10c0-.765.304-1.499.845-2.04zm13.455.655v4.9h.317a1.384 1.384 0 001.383-1.383V10a1.383 1.383 0 00-1.383-1.384h-.317zm-1.124-1.124c.24-.24.567-.376.907-.376h.534a2.883 2.883 0 012.883 2.884v2.133a2.883 2.883 0 01-2.883 2.883h-.534a1.284 1.284 0 01-1.283-1.283V8.4c0-.34.135-.667.376-.908z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M10.5 2.75a5.117 5.117 0 00-5.117 5.117.75.75 0 11-1.5 0 6.617 6.617 0 0113.234 0 .75.75 0 01-1.5 0A5.117 5.117 0 0010.5 2.75zm5.867 10.769a.75.75 0 01.75.75v.533a2.883 2.883 0 01-2.884 2.883h-1.6a.75.75 0 010-1.5h1.6a1.383 1.383 0 001.384-1.383v-.533a.75.75 0 01.75-.75z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M10.5 16.617a.317.317 0 100 .633h1.067a.317.317 0 000-.633H10.5zm-1.285-.968a1.82 1.82 0 011.285-.532h1.067a1.816 1.816 0 110 3.633H10.5a1.817 1.817 0 01-1.285-3.1z","clip-rule":"evenodd"}})])
          )
        }
      }
    